import { MaterialListStatus } from '../../../types/MasterList.types';

export const isStatusVerified = (status?: MaterialListStatus | null) =>
  status === MaterialListStatus.active || status === MaterialListStatus.ceased;

export const isStatusDeleted = (status?: MaterialListStatus | null) =>
  status === MaterialListStatus.deleted;

export const isStatusCeased = (status?: MaterialListStatus | null) =>
  status === MaterialListStatus.ceased;

export const isStatusAdded = (status?: MaterialListStatus | null) =>
  status === MaterialListStatus.added;

export const getStatusLabel = (status?: MaterialListStatus | null) => {
  if (!status) {
    return status;
  }

  return status === MaterialListStatus.deleted
    ? MaterialListStatus.ceased
    : status;
};
